<rd-popup-default-template
  [dialogContent]="dialogContent"
  [showCloseButton]="false"
  [showButtons]="true"
  [showSecondaryButton]="true"
  [primaryButtonText]="ok | translate"
  (primaryButtonClick)="okClick()"
  [secondaryButtonText]="cancel | translate"
  (secondaryButtonClick)="closeModal()">
  <ng-template #dialogContent>
    <div class="container">
      <rd-shared-icon
        *ngIf="dialogConfig.data.iconSymbol"
        class="icon mb-4"
        [iconSymbol]="dialogConfig.data.iconSymbol"></rd-shared-icon>
      <h1 class="title">{{ title }}</h1>
      <p class="description" [innerHTML]="description"></p>
    </div>
  </ng-template>
</rd-popup-default-template>
